import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IFetchStatus } from 'types/rest/IFetchStatus';
import { payoffRequestsInitialState } from './interfaces';
import { TOrderPayload } from '../../../types/order/vendorDashboard/TOrderPayload';
import { IPayoffRequestData } from '../../../types/order/title/IPayoffRequest';

export const PayoffRequestsReducer = createSlice({
  name: 'PayoffRequests',
  initialState: payoffRequestsInitialState,
  reducers: {
    setPayoffRequestsAction: (state, action: PayloadAction<TOrderPayload<IPayoffRequestData[]>>) => {
      state.payoffRequest[action.payload.orderId] = action.payload.value;
    },
    setPayoffRequestsFetchStatusAction: (state, action: PayloadAction<IFetchStatus>) => {
      state.payoffRequestFetchStatus = action.payload;
    },
    setPayoffRequestsErrorAction: (state, action: PayloadAction<string | null>) => {
      state.payoffRequestError = action.payload;
    },
    setCreatePayoffRequestsFetchStatusAction: (state, action: PayloadAction<IFetchStatus>) => {
      state.createPayoffRequestFetchStatus = action.payload;
    },
    setCreatePayoffRequestsErrorAction: (state, action: PayloadAction<string | null>) => {
      state.createPayoffRequestError = action.payload;
    },
    setCancelPayoffRequestsFetchStatusAction: (state, action: PayloadAction<IFetchStatus>) => {
      state.cancelPayoffRequestFetchStatus = action.payload;
    },
    setCancelPayoffRequestsErrorAction: (state, action: PayloadAction<string | null>) => {
      state.cancelPayoffRequestError = action.payload;
    },
  },
});

export const {
  setPayoffRequestsAction,
  setPayoffRequestsErrorAction,
  setPayoffRequestsFetchStatusAction,
  setCreatePayoffRequestsErrorAction,
  setCreatePayoffRequestsFetchStatusAction,
  setCancelPayoffRequestsErrorAction,
  setCancelPayoffRequestsFetchStatusAction,
} = PayoffRequestsReducer.actions;
